<div class="main-content mt-0">
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-4 col-md-2" *ngFor="let card of resumenCards; index as i">
        <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
        <div
          class="card card-stats"
          [ngClass]="{ 'card-stats__selected': i === 0 }"
          [routerLink]="card.route"
          [style.cursor]="card.route ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-7 col-lg-6">
                <div
                  class="icon-big text-center text-dark rounded shadow"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>
              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4
                  class="card-title mb-0"
                  [ngClass]="{ 'text-dark': i === 0, 'text-white': i !== 0 }"
                >
                  {{ card.value }}
                </h4>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="stats">
              <small [class]="i == 0 ? 'desc__selected' : 'desc'">{{
                card.desc
              }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 d-flex align-items-center justify-content-between">
        <div class="flex-grow-1 text-center">
          <a class="btn btn-dark btn-sm btn-new" [routerLink]="['/marketing']">
            Keywords
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/offPageCampaigns/urlMapping']"
          >
            URL Mapping
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/onPage']"
          >
            On-Page
          </a>
          <a class="btn btn-dark btn-sm btn-reg"> Internal Links </a>
        </div>
      </div>
    </div>

    <div class="row pb-3">
      <div class="col-12 d-flex align-items-center justify-content-between">
        <div class="flex-grow-1 text-center">
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/technicalQa']"
          >
            Technical QA
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/localSeo']"
          >
            Local SEO
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/offPage']"
          >
            Off-Page
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/performance']"
          >
            Performance
          </a>
        </div>
      </div>
    </div>

    <div class="url-mapping-container p-4" *ngIf="!loading">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center mb-4">
        <div class="d-flex align-items-center gap-3">
          <div class="header-icon bg-primary text-white rounded p-2">
            <i class="fas fa-link fa-lg"></i>
          </div>
          <div class="pl-2">
            <h2 class="h4 mb-0 fw-bold">INTERNAL LINKS</h2>
            <!-- <p class="text-muted mb-0 small">
              Optimize internal linking structure. Build relevance, distribute
              authority, and support strategic page relationships.
            </p> -->
          </div>
        </div>
        <div class="d-flex gap-2">
          <!-- <button class="btn btn-outline-secondary btn-sm p-1 btn-header">
            <i class="far fa-play-circle me-2"></i> How it works
          </button> -->
          <button class="btn btn-outline-secondary btn-sm p-1 btn-header">
            <i class="fas fa-download me-2"></i> Export Report
          </button>
          <!-- <button class="btn btn-sm btn-add p-1 btn-header">
            <i class="fas fa-plus me-2"></i> New Link Opportunity
          </button> -->
        </div>
      </div>

      <!-- Main Layout -->
      <div class="row">
        <div class="col-lg-12">
          <!-- Filters -->
          <div class="row mb-0 px-3">
            <div class="col-3">
              <label class="text-dark" for="urlMapping"
                ><strong>Filters</strong></label
              >
            </div>
            <div class="col-9 d-flex justify-content-end mt-2 pr-0">
              <button
                class="btn btn-outline-secondary btn-sm btn-filter"
                (click)="onFilterChange()"
              >
                Find
              </button>
            </div>
            <div class="col-2 filter-card">
              <label class="form-label small fw-bold text-dark mb-1 d-block"
                >Location</label
              >
              <select
                class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
                [(ngModel)]="pendingLocation"
              >
                <option *ngFor="let loc of locations" [value]="loc.value">
                  {{ loc.label }}
                </option>
              </select>
            </div>

            <div class="col-2 filter-card">
              <label class="form-label small fw-bold text-dark mb-1 d-block"
                >Universe</label
              >
              <select
                class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
                [(ngModel)]="pendingUniverse"
              >
                <option *ngFor="let uni of universes" [value]="uni.value">
                  {{ uni.label }}
                </option>
              </select>
            </div>

            <div class="col-2 filter-card">
              <label class="form-label small fw-bold text-dark mb-1 d-block"
                >Category</label
              >
              <select
                class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
                [(ngModel)]="pendingCategory"
              >
                <option *ngFor="let cat of categories" [value]="cat.value">
                  {{ cat.label }}
                </option>
              </select>
            </div>

            <div class="col-2 filter-card">
              <label class="form-label small fw-bold text-dark mb-1 d-block"
                >Target URL</label
              >
              <select
                class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
              >
                <option>All</option>
              </select>
            </div>

            <div class="col-2 filter-card">
              <label class="form-label small fw-bold text-dark mb-1 d-block"
                >Link Status</label
              >
              <select
                class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
              >
                <option>All</option>
              </select>
            </div>

            <div class="col-2 filter-card">
              <label class="form-label small fw-bold text-dark mb-1 d-block"
                >Priority</label
              >
              <select
                class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
              >
                <option>All</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="row">
        <div class="col-12"> -->
          <!-- Statistics -->
          <div class="row">
            <div class="col-12">
              <div
                class="row m-0 align-items-stretch flex-nowrap custom-scroll-x p-0 gap-3"
              >
                <!-- Stat 1 -->
                <div class="col p-0 pr-1 d-flex">
                  <div class="card shadow-sm border-0 bg-white w-100 mt-4">
                    <div class="card-body px-1 py-1 d-flex">
                      <div
                        class="stat-icon-filled bg-primary bg-opacity-10 text-light me-3 p-2 rounded"
                      >
                        <span class="material-icons" style="font-size: 20px"
                          >link</span
                        >
                      </div>
                      <div class="space-cards">
                        <div
                          class="text-uppercase fw-bold text-dark mb-1"
                          style="font-size: 0.65rem; letter-spacing: 0.5px"
                        >
                          <strong>TOTAL INTERNAL LINKS</strong>
                        </div>
                        <h3 class="mb-1 fw-bold text-dark">1,842</h3>
                        <div class="small fw-medium text-success">
                          <span
                            class="material-icons"
                            style="font-size: 14px; vertical-align: middle"
                            >arrow_upward</span
                          >
                          12.4% vs last 30 days
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Stat 2 -->
                <div class="col p-0 pr-1 d-flex">
                  <div class="card shadow-sm border-0 bg-white w-100 mt-4">
                    <div class="card-body px-1 py-1 d-flex">
                      <div
                        class="stat-icon-filled bg-success bg-opacity-10 text-light me-3 p-2 rounded"
                      >
                        <span class="material-icons" style="font-size: 20px"
                          >track_changes</span
                        >
                      </div>
                      <div class="space-cards">
                        <div
                          class="text-uppercase fw-bold text-dark mb-1"
                          style="font-size: 0.65rem; letter-spacing: 0.5px"
                        >
                          <strong>LINK OPPORTUNITIES</strong>
                        </div>
                        <h3 class="mb-1 fw-bold text-dark">126</h3>
                        <div class="small fw-medium text-success">
                          <span
                            class="material-icons"
                            style="font-size: 14px; vertical-align: middle"
                            >arrow_upward</span
                          >
                          18.7% vs last 30 days
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Stat 3 -->
                <div class="col p-0 pr-1 d-flex">
                  <div class="card shadow-sm border-0 bg-white w-100 mt-4">
                    <div class="card-body px-1 py-1 d-flex">
                      <div
                        class="stat-icon-filled bg-warning bg-opacity-10 text-light me-3 p-2 rounded"
                      >
                        <span class="material-icons" style="font-size: 20px"
                          >star</span
                        >
                      </div>
                      <div class="space-cards">
                        <div
                          class="text-uppercase fw-bold text-dark mb-1"
                          style="font-size: 0.65rem; letter-spacing: 0.5px"
                        >
                          <strong>PAGES NEEDING SUPPORT</strong>
                        </div>
                        <h3 class="mb-1 fw-bold text-dark">21</h3>
                        <div class="small fw-medium text-danger">
                          <span
                            class="material-icons"
                            style="font-size: 14px; vertical-align: middle"
                            >arrow_downward</span
                          >
                          4 vs last 30 days
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Stat 4 -->
                <div class="col p-0 pr-1 d-flex">
                  <div class="card shadow-sm border-0 bg-white w-100 mt-4">
                    <div class="card-body px-1 py-1 d-flex">
                      <div
                        class="stat-icon-filled bg-danger bg-opacity-10 text-light me-3 p-2 rounded"
                      >
                        <span class="material-icons" style="font-size: 20px"
                          >warning</span
                        >
                      </div>
                      <div class="space-cards">
                        <div
                          class="text-uppercase fw-bold text-dark mb-1"
                          style="font-size: 0.65rem; letter-spacing: 0.5px"
                        >
                          <strong>CRITICAL LINK ISSUES</strong>
                        </div>
                        <h3 class="mb-1 fw-bold text-dark">5</h3>
                        <div class="small fw-medium text-danger">
                          <span
                            class="material-icons"
                            style="font-size: 14px; vertical-align: middle"
                            >arrow_downward</span
                          >
                          2 vs last 30 days
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Stat 5 -->
                <div class="col p-0 pr-1 d-flex">
                  <div class="card shadow-sm border-0 bg-white w-100 mt-4">
                    <div class="card-body px-1 py-1 d-flex">
                      <div
                        class="stat-icon-filled bg-purple bg-opacity-10 text-purple me-3 p-2 rounded"
                      >
                        <span class="material-icons" style="font-size: 20px"
                          >article</span
                        >
                      </div>
                      <div class="space-cards">
                        <div
                          class="text-uppercase fw-bold text-dark mb-1"
                          style="font-size: 0.65rem; letter-spacing: 0.5px"
                        >
                          <strong>ORPHAN PAGES</strong>
                        </div>
                        <h3 class="mb-1 fw-bold text-dark">3</h3>
                        <div class="small fw-medium text-muted">
                          No internal links
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        <!-- </div>
      </div> -->
      <div class="row">
        <div class="col-lg-12 d-flex">
          <!-- Internal Link Opportunities Table -->
          <div class="card shadow-sm flex-grow-1 mt-0">
            <div class="card-header bg-white border-bottom-0 pb-0 px-0">
              <h4 class="fw-bold fs-6 mb-3 mt-0 d-flex align-items-center pl-3">
                <strong>INTERNAL LINK OPPORTUNITIES</strong>
                <i class="fas fa-info-circle text-muted ms-1 small pl-1"></i>
              </h4>
              <ul
                class="nav nav-tabs nav-tabs-custom border-0 flex-nowrap custom-scroll-x px-0 pb-4 ul-tabs-custom"
              >
                <li class="nav-item">
                  <a
                    class="nav-link a-internal-link"
                    [class.active]="activeInternalLinksTab === 'All Opportunities'"
                    [class.fw-bold]="activeInternalLinksTab === 'All Opportunities'"
                    (click)="setActiveInternalLinksTab('All Opportunities')"
                    href="javascript:void(0)"
                    ><strong>All Opportunities</strong
                    ><span
                      class="badge bg-light border border-info text-dark ms-1"
                      >100</span
                    ></a
                  >
                </li>
                <li class="nav-item">
                  <a 
                    class="nav-link a-internal-link" 
                    [class.active]="activeInternalLinksTab === 'Missing Links'"
                    [class.fw-bold]="activeInternalLinksTab === 'Missing Links'"
                    (click)="setActiveInternalLinksTab('Missing Links')"
                    href="javascript:void(0)"
                    ><strong>Missing Links</strong>
                    <span class="badge bg-primary-light text-primary ms-1"
                      >84</span
                    ></a
                  >
                </li>
                <li class="nav-item">
                  <a 
                    class="nav-link a-internal-link" 
                    [class.active]="activeInternalLinksTab === 'Update Anchor'"
                    [class.fw-bold]="activeInternalLinksTab === 'Update Anchor'"
                    (click)="setActiveInternalLinksTab('Update Anchor')"
                    href="javascript:void(0)"
                    ><strong>Update Anchor</strong>
                    <span class="badge bg-primary-light text-primary ms-1"
                      >21</span
                    ></a
                  >
                </li>
                <li class="nav-item">
                  <a 
                    class="nav-link a-internal-link" 
                    [class.active]="activeInternalLinksTab === 'Fix Issues'"
                    [class.fw-bold]="activeInternalLinksTab === 'Fix Issues'"
                    (click)="setActiveInternalLinksTab('Fix Issues')"
                    href="javascript:void(0)"
                    ><strong>Fix Issues</strong>
                    <span class="badge bg-primary-light text-primary ms-1"
                      >21</span
                    ></a
                  >
                </li>
                <li class="nav-item">
                  <a 
                    class="nav-link a-internal-link" 
                    [class.active]="activeInternalLinksTab === 'Orphan Pages'"
                    [class.fw-bold]="activeInternalLinksTab === 'Orphan Pages'"
                    (click)="setActiveInternalLinksTab('Orphan Pages')"
                    href="javascript:void(0)"
                    ><strong>Orphan Pages</strong>
                    <span class="badge bg-primary-light text-primary ms-1"
                      >3</span
                    ></a
                  >
                </li>
              </ul>
            </div>
            <div class="card-body p-0">
              <div class="table-responsive">
                <table class="table table-hover align-middle mb-0 text-sm">
                  <thead class="bg-light text-uppercase small">
                    <tr>
                      <th class="ps-3 kw-url-mapping-header">SOURCE PAGE</th>
                      <th class="kw-url-mapping-header">TARGET PAGE</th>
                      <th class="kw-url-mapping-header">RELATIONSHIP</th>
                      <th class="kw-url-mapping-header">STATUS</th>
                      <th class="kw-url-mapping-header">SUGGESTED ANCHOR</th>
                      <th class="kw-url-mapping-header">CONTEXT</th>
                      <th class="kw-url-mapping-header">PRIORITY</th>
                      <th class="kw-url-mapping-header">CONFIDENCE</th>
                      <th class="pe-3 text-end kw-url-mapping-header">
                        ACTION
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="let row of opportunities"
                      [class.table-active]="selectedOpportunity === row"
                      (click)="selectOpportunity(row)"
                      style="cursor: pointer"
                    >
                      <td
                        class="ps-3 text-primary fw-medium"
                        style="font-size: 0.8rem"
                      >
                        {{ row.sourcePage }}
                      </td>
                      <td class="text-dark fw-medium" style="font-size: 0.8rem">
                        {{ row.targetPage }}
                      </td>
                      <td class="text-secondary" style="font-size: 0.8rem">
                        {{ row.relationship }}
                      </td>
                      <td>
                        <span
                          class="badge rounded-pill"
                          [ngClass]="row.statusClass"
                          >{{ row.status }}</span
                        >
                      </td>
                      <td class="text-dark" style="font-size: 0.8rem">
                        {{ row.suggestedAnchor }}
                      </td>
                      <td
                        class="text-muted"
                        style="font-size: 0.8rem; max-width: 150px"
                      >
                        {{ row.context }}
                      </td>
                      <td>
                        <span
                          class="badge rounded-pill"
                          [ngClass]="row.priorityClass"
                          >{{ row.priority }}</span
                        >
                      </td>
                      <td>
                        <div class="d-flex align-items-center gap-1">
                          <i
                            class="fas fa-circle rounded-circle"
                            [ngClass]="row.confidenceIconClass"
                            style="font-size: 8px"
                          ></i>
                          <span class="fw-medium" style="font-size: 0.8rem">{{
                            row.confidence
                          }}</span>
                        </div>
                      </td>
                      <td class="pe-3 text-end">
                        <button
                          class="btn btn-sm text-decoration-none fw-medium btn-review"
                          [ngClass]="row.actionBtnClass"
                        >
                          {{ row.action }}
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- <div
                class="d-flex justify-content-between align-items-center p-3 border-top"
              >
                <span class="small text-muted"
                  >Showing 1 to 8 of 126 results</span
                >
                <div class="d-flex gap-1 align-items-center">
                  <button class="btn btn-sm btn-outline-secondary border-0">
                    <i class="fas fa-chevron-left text-muted"></i>
                  </button>
                  <button class="btn btn-sm btn-dark px-2" style="border: 0">
                    1
                  </button>
                  <button class="btn btn-sm btn-outline-secondary px-2">
                    2
                  </button>
                  <button class="btn btn-sm btn-outline-secondary px-2">
                    3
                  </button>
                  <span class="px-2">...</span>
                  <button class="btn btn-sm btn-outline-secondary px-2">
                    16
                  </button>
                  <button class="btn btn-sm btn-outline-secondary px-2">
                    <i class="fas fa-chevron-right text-muted"></i>
                  </button>
                </div>
                <select
                  class="form-select form-select-sm w-auto"
                  style="cursor: pointer"
                >
                  <option>10 / page</option>
                </select>
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-8 d-flex">
          <!-- Selected Opportunity Review -->
          <div class="card shadow-sm border-0 flex-grow-1 pl-0 mt-0 mb-0">
            <div
              class="card-header bg-white border-bottom-0 d-flex justify-content-between align-items-center pb-2 px-3"
            >
              <h4
                class="fw-bold text-uppercase mb-0 d-flex align-items-center"
                style="font-size: 0.9rem"
              >
                <strong>SELECTED OPPORTUNITY</strong>
              </h4>
            </div>
            <div class="card-body pt-0 px-3">
              <div
                class="d-flex align-items-center justify-content-between mb-3 pb-2"
              >
                <div style="font-size: 0.75rem">
                  <div class="text-dark mb-1">
                    <strong>Source Page</strong>
                  </div>
                  <a
                    href="#"
                    class="text-primary fw-medium text-decoration-none"
                    >/blog/legal-courier-guide/
                    <i
                      class="fas fa-external-link-alt ms-1"
                      style="font-size: 10px"
                    ></i
                  ></a>
                </div>
                <div><i class="fas fa-arrow-right text-muted p-1"></i></div>
                <div class="text-end" style="font-size: 0.75rem">
                  <div class="text-dark mb-1">
                    <strong>Target Page</strong>
                  </div>
                  <a
                    href="#"
                    class="text-primary fw-medium text-decoration-none"
                    >/legal-courier-miami/
                    <i
                      class="fas fa-external-link-alt ms-1"
                      style="font-size: 10px"
                    ></i
                  ></a>
                </div>
              </div>

              <div class="table-responsive">
                <table
                  class="table table-sm table-borderless mb-3 border-top border-bottom border-info"
                  style="font-size: 0.8rem"
                >
                  <tbody>
                    <tr class="">
                      <td class="text-dark py-2">Relationship</td>
                      <td class="text-end py-2 fw-medium text-dark">
                        Supporting
                        <i class="fas fa-arrow-right mx-1 small text-muted"></i>
                        Primary
                      </td>
                    </tr>
                    <tr class="">
                      <td class="text-dark py-2">Mapping Alignment</td>
                      <td class="text-end py-2">
                        <span
                          class="badge bg-success-light text-success fw-medium"
                          >Strong</span
                        >
                      </td>
                    </tr>
                    <tr class="">
                      <td class="text-dark py-2">Contextual Relevance</td>
                      <td class="text-end py-2">
                        <span
                          class="badge bg-success-light text-success fw-medium"
                          >High</span
                        >
                      </td>
                    </tr>
                    <tr class="">
                      <td class="text-dark py-2">Source Authority</td>
                      <td class="text-end py-2 fw-medium text-dark">
                        Strong (DR 32)
                      </td>
                    </tr>
                    <tr class="">
                      <td class="text-dark py-2">Target Support Need</td>
                      <td class="text-end py-2">
                        <span
                          class="badge bg-danger-light text-danger fw-medium"
                          >High</span
                        >
                      </td>
                    </tr>
                    <tr class="">
                      <td class="text-dark py-2">Current Link Status</td>
                      <td class="text-end py-2">
                        <span
                          class="badge bg-danger-light text-danger fw-medium"
                          >Missing</span
                        >
                      </td>
                    </tr>
                    <tr class="">
                      <td class="text-dark py-2 align-middle">
                        Suggested Anchor
                      </td>
                      <td class="text-end py-2 fw-medium text-dark">
                        legal courier in Miami
                      </td>
                    </tr>
                    <tr class="">
                      <td class="text-dark py-2">Anchor Risk</td>
                      <td class="text-end py-2">
                        <span
                          class="badge bg-success-light text-success fw-medium"
                          >Low</span
                        >
                      </td>
                    </tr>
                    <tr>
                      <td class="text-dark py-2 align-middle">
                        Recommended Placement
                      </td>
                      <td
                        class="text-end py-2 fw-medium text-dark text-wrap"
                        style="max-width: 150px"
                      >
                        Section: Serving Law Firms in Miami - Paragraph 4
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="mb-3">
                <h5
                  class="small fw-bold text-uppercase mb-2 text-dark ai-rationale"
                >
                  AI RATIONALE
                </h5>
                <p class="text-muted lh-sm mb-0" style="font-size: 0.8rem">
                  This page provides educational content for law firms in Miami.
                  Linking to the primary transactional page strengthens topical
                  relevance and distributes authority to the main conversion
                  page.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-4 d-flex pl-0">
          <!-- <div class="card-body pt-0 px-3"></div> -->
          <!-- Link Action Center -->
          <div
            class="card shadow-sm border-0 card-opportunity sc mt-0 pl-0 mb-0 flex-grow-1 custom-scroll-x"
          >
            <div class="mb-0 overflow-hidden">
              <div
                class="pb-0 p-2 d-flex justify-content-between align-items-center"
              >
                <div
                  class="fw-bold text-dark text-uppercase d-flex align-items-center ms-2"
                  style="font-size: 0.8rem"
                >
                  <h4 class="text-nowrap">
                    <strong> LINK ACTION CENTER</strong>
                  </h4>
                  <i class="fas fa-info-circle text-muted ms-1 small pl-1"></i>
                </div>
                <div
                  class="text-uppercase fw-bold text-dark me-2 mb-4 text-end"
                  style="font-size: 0.7rem"
                >
                  EXECUTION MODE
                </div>
              </div>
              <div class="p-3 bg-white">
                <table
                  class="table table-borderless table-sm mb-3"
                  style="font-size: 0.8rem"
                >
                  <tr>
                    <td class="text-dark w-50 py-1">Decision Origin</td>
                    <td class="text-start py-1">
                      <span class="fw-medium text-primary"
                        ><i class="fas fa-robot"></i> AI Detected</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <td class="text-dark py-1">AI Confidence</td>
                    <td class="text-start py-1">
                      <div class="d-flex align-items-center gap-2">
                        <span
                          class="badge rounded-pill bg-light text-dark fw-normal border"
                          >High</span
                        >
                        <span class="text-success fw-bold pl-3">91%</span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-dark py-1">Risk Level</td>
                    <td class="text-start py-1">
                      <span class="badge bg-success-light text-success"
                        >Low</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <td class="text-dark py-1">
                      <strong>Execution Mode</strong>
                    </td>
                    <td class="text-start py-1">
                      <span class="badge bg-warning-light text-warning"
                        ><i class="fas fa-user"></i> Human Approval
                        Required</span
                      >
                    </td>
                  </tr>
                  <tr class="border-top border-muted">
                    <td class="text-dark py-1 pt-3">Recommended Action</td>
                    <td class="text-start py-1 pt-3">
                      <span
                        class="badge bg-success-light text-success fw-medium"
                        >Add Internal Link</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <td class="text-dark py-1">Source URL</td>
                    <td class="text-start py-1">
                      <a href="#" class="text-primary text-decoration-none"
                        >/blog/legal-courier-guide/
                        <i
                          class="fas fa-external-link-alt"
                          style="font-size: 10px"
                        ></i
                      ></a>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-dark py-1">Target URL</td>
                    <td class="text-start py-1">
                      <a href="#" class="text-primary text-decoration-none"
                        >/legal-courier-miami/
                        <i
                          class="fas fa-external-link-alt"
                          style="font-size: 10px"
                        ></i
                      ></a>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-dark py-1">Anchor Text</td>
                    <td class="text-start py-1 fw-medium text-dark">
                      legal courier in Miami
                    </td>
                  </tr>
                  <tr class="border-bottom border-muted">
                    <td class="text-dark py-1">Placement Suggestion</td>
                    <td class="text-start py-1 text-dark">
                      Section: Serving Law Firms in Miami<br />Paragraph 4
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <!-- <div class="col-12 ">
          <div class="row"> -->
        <!-- Pages needing support -->
        <div class="col-4">
          <div class="card shadow-sm h-100 mt-0 mb-0 flex-grow-1">
            <div class="card-header bg-white border-0 pb-0 pt-3">
              <h4
                class="fw-bold text-uppercase mb-0"
                style="font-size: 0.75rem"
              >
                <strong>PAGES NEEDING INTERNAL SUPPORT</strong>
              </h4>
            </div>
            <div class="card-body p-0 pt-2 custom-scroll-x">
              <table class="table table-sm table-borderless text-sm mb-0">
                <thead
                  class="text-uppercase text-muted"
                  style="font-size: 0.65rem"
                >
                  <tr>
                    <th class="ps-3 fw-bold head-table">
                      <strong>PAGE</strong>
                    </th>
                    <th class="text-center fw-bold head-table">
                      <strong>CURRENT LINKS</strong>
                    </th>
                    <th class="text-center fw-bold head-table">
                      <strong>SUPPORT RANGE</strong>
                    </th>
                    <th class="text-center fw-bold head-table">
                      <strong>GAP</strong>
                    </th>
                    <th class="pe-3 fw-bold head-table">
                      <strong>PRIORITY</strong>
                    </th>
                  </tr>
                </thead>
                <tbody style="font-size: 0.75rem">
                  <tr *ngFor="let item of pagesNeedingSupport">
                    <td class="ps-3 text-primary">{{ item.page }}</td>
                    <td class="text-center">{{ item.currentLinks }}</td>
                    <td class="text-center text-muted">
                      {{ item.recommendedRange }}
                    </td>
                    <td
                      class="text-center fw-bold"
                      [ngClass]="
                        item.gap <= -6 ? 'text-danger' : 'text-warning'
                      "
                    >
                      {{ item.gap }}
                    </td>
                    <td class="pe-3">
                      <span
                        class="badge rounded-pill"
                        [ngClass]="item.priorityClass"
                        >{{ item.priority }}</span
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="card-footer bg-white border-0 text-end">
              <a
                href="#"
                class="text-decoration-none text-primary small d-flex align-items-center justify-content-end fw-medium"
                style="font-size: 0.75rem"
                >View all pages needing support
                <i class="fas fa-arrow-right ms-1"></i
              ></a>
            </div>
          </div>
        </div>

        <!-- Link Health Overview -->
        <div class="col-4 pl-0">
          <div class="card shadow-sm h-100 mt-0 mb-0 flex-grow-1">
            <div class="card-header bg-white border-0 pb-0 pt-3">
              <h4
                class="fw-bold text-uppercase mb-0"
                style="font-size: 0.75rem"
              >
                <strong>LINK HEALTH OVERVIEW</strong>
              </h4>
            </div>
            <div class="card-body d-flex p-1 pt-4 gap-3">
              <div
                class="position-relative d-flex justify-content-center align-items-center"
                style="
                  width: 100px;
                  height: 100px;
                  border-radius: 50%;
                  border: 12px solid #28a745;
                "
              >
                <div class="text-center">
                  <h4 class="fw-bold text-dark mb-0 fs-5">1,842</h4>
                  <div style="font-size: 0.6rem" class="text-muted fw-bold">
                    Total Links
                  </div>
                </div>
              </div>
              <div class="flex-grow-1">
                <ul class="list-unstyled mb-0" style="font-size: 0.75rem">
                  <li class="mb-2 d-flex align-items-start gap-2">
                    <i
                      class="fas fa-circle text-success"
                      style="font-size: 8px; margin-top: 4px"
                    ></i>
                    <div>
                      <div class="text-dark fw-medium lh-sm">Active</div>
                      <div class="text-muted">1,798 (97.6%)</div>
                    </div>
                  </li>
                  <li class="mb-2 d-flex align-items-start gap-2">
                    <i
                      class="fas fa-circle text-warning"
                      style="font-size: 8px; margin-top: 4px"
                    ></i>
                    <div>
                      <div class="text-dark fw-medium lh-sm">Redirected</div>
                      <div class="text-muted">28 (1.5%)</div>
                    </div>
                  </li>
                  <li class="mb-2 d-flex align-items-start gap-2">
                    <i
                      class="fas fa-circle text-danger"
                      style="font-size: 8px; margin-top: 4px"
                    ></i>
                    <div>
                      <div class="text-dark fw-medium lh-sm">Broken</div>
                      <div class="text-muted">2 (0.1%)</div>
                    </div>
                  </li>
                  <li class="d-flex align-items-start gap-2">
                    <i
                      class="fas fa-circle text-primary"
                      style="font-size: 8px; margin-top: 4px"
                    ></i>
                    <div>
                      <div class="text-dark fw-medium lh-sm">No Follow</div>
                      <div class="text-muted">14 (0.8%)</div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-footer bg-white border-0 text-center">
              <a
                href="#"
                class="text-decoration-none text-primary small d-flex align-items-center justify-content-center fw-medium"
                style="font-size: 0.75rem"
                >View full link health report
                <i class="fas fa-arrow-right ms-1"></i
              ></a>
            </div>
          </div>
        </div>

        <!-- Critical Link Issues -->
        <div class="col-4 pl-0">
          <div class="card shadow-sm h-100 mt-0 mb-0 flex-grow-1">
            <div class="card-header bg-white border-0 pb-0 pt-3">
              <h4
                class="fw-bold text-uppercase mb-0"
                style="font-size: 0.75rem"
              >
                <strong>CRITICAL LINK ISSUES</strong>
              </h4>
            </div>
            <div class="card-body p-3">
              <ul class="list-group list-group-flush border-0">
                <li
                  class="list-group-item px-0 py-2 border-0 d-flex justify-content-between align-items-center issues"
                  style="font-size: 0.8rem"
                >
                  <span class="text-dark">Broken Internal Links</span>
                  <span class="text-danger fw-bold">2</span>
                </li>
                <li
                  class="list-group-item px-0 py-2 border-0 d-flex justify-content-between align-items-center issues"
                  style="font-size: 0.8rem"
                >
                  <span class="text-dark">Redirect Chains</span>
                  <span class="text-danger fw-bold">2</span>
                </li>
                <li
                  class="list-group-item px-0 py-2 border-0 d-flex justify-content-between align-items-center issues"
                  style="font-size: 0.8rem"
                >
                  <span class="text-dark">Orphan Pages</span>
                  <span class="text-danger fw-bold">3</span>
                </li>
                <li
                  class="list-group-item px-0 py-2 border-0 d-flex justify-content-between align-items-center issues"
                  style="font-size: 0.8rem"
                >
                  <span class="text-dark">Multiple Links - Same Anchor</span>
                  <span class="text-danger fw-bold">4</span>
                </li>
                <li
                  class="list-group-item px-0 py-2 border-0 d-flex justify-content-between align-items-center issues"
                  style="font-size: 0.8rem"
                >
                  <span class="text-dark">Links to 404 Pages</span>
                  <span class="text-danger fw-bold">1</span>
                </li>
              </ul>
            </div>
            <div class="card-footer bg-white border-0 text-end">
              <a
                href="#"
                class="text-decoration-none text-primary small d-flex align-items-center justify-content-end fw-medium"
                style="font-size: 0.75rem"
                >View all issues <i class="fas fa-arrow-right ms-1"></i
              ></a>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-8 d-flex">
          <!-- <div class="card mt-4 shadow-sm border-0 flex-grow-1">
            <div class="card-header bg-white pb-2 pt-3">
              <h4
                class="fw-bold text-dark text-uppercase"
                style="font-size: 0.7rem; letter-spacing: 0.5px"
              >
                <strong>HOW INTERNAL LINKS WORKS IN THE ECOSYSTEM</strong>
              </h4>
            </div>
            <div class="card-body pt-0">
              <div
                class="d-flex flex-nowrap align-items-center gap-2"
                style="overflow-x: auto; padding-bottom: 4px"
              >
                <div
                  class="d-flex border p-2 rounded flex-shrink-0 card-how-internal-links"
                >
                  <span
                    class="material-icons text-success me-2 mb-5"
                    style="font-size: 30px"
                    >map</span
                  >
                  <div class="text-start" style="font-size: 0.6rem">
                    <div class="fw-bold text-success">
                      <strong>URL MAPPING</strong>
                    </div>
                    Provides architecture, relationships and link directions
                  </div>
                </div>
                <span
                  class="material-icons text-muted flex-shrink-0"
                  style="font-size: 16px"
                  >arrow_forward</span
                >
                <div
                  class="d-flex border p-2 rounded flex-shrink-0 card-how-internal-links"
                >
                  <span
                    class="material-icons text-primary me-2 mb-5"
                    style="font-size: 30px"
                    >link</span
                  >
                  <div class="text-start" style="font-size: 0.6rem">
                    <div class="fw-bold text-primary">
                      <strong>INTERNAL LINKS</strong>
                    </div>
                    Executes connections, optimizes anchors and distributes
                    authority
                  </div>
                </div>
                <span
                  class="material-icons text-muted flex-shrink-0"
                  style="font-size: 16px"
                  >arrow_forward</span
                >
                <div
                  class="d-flex border p-2 rounded flex-shrink-0 opacity-75 card-how-internal-links"
                >
                  <span
                    class="material-icons text-warning me-2 mb-5"
                    style="font-size: 30px"
                    >article</span
                  >
                  <div class="text-start" style="font-size: 0.6rem">
                    <div class="fw-bold text-warning">
                      <strong>ON-PAGE</strong>
                    </div>
                    Creates context and content that enables natural linking
                  </div>
                </div>
                <span
                  class="material-icons text-muted flex-shrink-0"
                  style="font-size: 16px"
                  >arrow_forward</span
                >
                <div
                  class="d-flex border p-2 rounded flex-shrink-0 opacity-75 card-how-internal-links"
                >
                  <span
                    class="material-icons text-purple me-2 mb-5"
                    style="font-size: 30px"
                    >trending_up</span
                  >
                  <div class="text-start" style="font-size: 0.6rem">
                    <div class="fw-bold text-purple">
                      <strong>PERFORMANCE</strong>
                    </div>
                    Measures impact on rankings, traffic and conversions
                  </div>
                </div>
                <span
                  class="material-icons text-muted flex-shrink-0"
                  style="font-size: 16px"
                  >arrow_forward</span
                >
                <div
                  class="d-flex border p-2 rounded flex-shrink-0 opacity-75 card-how-internal-links"
                >
                  <span
                    class="material-icons text-primary me-2 mb-5"
                    style="font-size: 30px"
                    >manage_search</span
                  >
                  <div class="text-start" style="font-size: 0.6rem">
                    <div class="fw-bold text-primary">
                      <strong>TECHNICAL QA</strong>
                    </div>
                    Ensures links are healthy, accessible and crawlable
                  </div>
                </div>
              </div>
            </div>
          </div> -->
          <div
            class="card border-0 shadow-sm governance-card mt-3 mb-3 flex-grow-1"
          >
            <!-- Additional widgets like GOVERNANCE & LEGEND from the image -->
            <div class="governance-scroll-wrapper mt-3">
              <div class="d-inline-flex px-3 py-2" style="min-width: 100%">
                <div style="min-width: 180px; font-size: 0.65rem" class="pe-3">
                  <div class="fw-bold text-uppercase mb-2 text-dark">
                    <h4
                      class="fw-bold mb-0 text-uppercase"
                      style="font-size: 0.75rem"
                    >
                      <strong>LINKING GOVERNANCE</strong>
                    </h4>
                  </div>
                  <table class="table table-borderless table-sm mb-0">
                    <tr>
                      <td class="px-0 py-1 text-dark d-flex mr-1">
                        AI Autonomy Level
                      </td>
                      <td class="px-0 py-1 text-end">
                        <span class="badge bg-warning-light text-warning"
                          >Governed Autonomy</span
                        >
                      </td>
                    </tr>
                    <tr>
                      <td class="px-0 py-1 text-dark d-flex mr-3">
                        Auto-Execute Rules
                      </td>
                      <td class="px-0 py-1 text-end fw-bold">6 Active Rules</td>
                    </tr>
                    <tr>
                      <td class="px-0 py-1 text-dark d-flex mr-3">
                        Last Review
                      </td>
                      <td class="px-0 py-1 text-end fw-bold">Jan 18, 2025</td>
                    </tr>
                  </table>
                </div>
                <div
                  style="min-width: 150px; font-size: 0.65rem"
                  class="pl-5 border-start"
                >
                  <div class="fw-bold text-uppercase mb-2 text-dark">
                    <strong>LEGEND</strong>
                  </div>
                  <div class="mb-1 d-flex align-items-center gap-2">
                    <i
                      class="fas fa-circle text-danger"
                      style="font-size: 8px; flex-shrink: 0"
                    ></i>
                    High Priority
                  </div>
                  <div class="mb-1 d-flex align-items-center gap-2">
                    <i
                      class="fas fa-circle text-warning"
                      style="font-size: 8px; flex-shrink: 0"
                    ></i>
                    Medium Priority
                  </div>
                  <div class="mb-1 d-flex align-items-center gap-2">
                    <i
                      class="fas fa-circle text-success"
                      style="font-size: 8px; flex-shrink: 0"
                    ></i>
                    Low Priority
                  </div>
                  <div class="mb-1 d-flex align-items-center gap-2">
                    <i
                      class="fas fa-circle text-secondary"
                      style="font-size: 8px; flex-shrink: 0"
                    ></i>
                    Info / Neutral
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-4 d-flex pl-0">
          <div
            class="card shadow-sm border-0 rounded-4 sc flex-grow-1 mt-3 mb-3"
          >
            <!-- Premium Header -->
            <div
              class="card-header bg-transparent border-0 pt-4 pb-2 px-4 d-flex align-items-center justify-content-between"
            >
              <div class="fw-bold text-dark d-flex align-items-center gap-2">
                <h4
                  class="fw-bold mb-0 text-uppercase"
                  style="font-size: 0.75rem"
                >
                  <strong>CHANGE PREVIEW</strong>
                </h4>
              </div>
            </div>

            <!-- Main Body -->
            <div class="card-body px-4 py-3 d-flex flex-column gap-3">
              <div class="row g-3">
                <!-- Current Block -->
                <div class="col-6">
                  <div
                    class="d-flex justify-content-between align-items-center mb-2 px-1"
                  >
                    <div
                      class="text-dark fw-semibold d-flex align-items-center gap-1"
                      style="font-size: 0.75rem"
                    >
                      Current
                    </div>
                    <!-- <span style="font-size: 0.7rem; visibility: hidden"
                        >Visual</span
                      > -->
                  </div>
                  <div
                    class="border rounded p-3 text-secondary bg-light position-relative"
                    style="
                      font-size: 0.75rem;
                      min-height: 155px;
                      max-height: 155px;
                      overflow-y: auto;
                      line-height: 1.6;
                      border-style: dashed !important;
                    "
                  >
                    Law firms require time-sensitive delivery throughout Miami.
                  </div>
                </div>
                <!-- Proposed Block -->
                <div class="col-6">
                  <div
                    class="d-flex justify-content-between align-items-center mb-2 px-1"
                  >
                    <div
                      class="text-dark fw-semibold d-flex align-items-center gap-1"
                      style="font-size: 0.75rem"
                    >
                      Proposed
                    </div>
                    <a
                      href="#"
                      class="text-primary text-decoration-none fw-medium d-flex align-items-center gap-1"
                      style="font-size: 0.7rem; transition: opacity 0.2s"
                      onmouseover="this.style.opacity = '0.7'"
                      onmouseout="this.style.opacity = '1'"
                    >
                      Visual
                    </a>
                  </div>
                  <div
                    class="border border-primary-subtle rounded p-3 text-dark position-relative shadow-sm bg-white"
                    style="
                      font-size: 0.75rem;
                      min-height: 155px;
                      max-height: 155px;
                      overflow-y: auto;
                      line-height: 1.6;
                    "
                  >
                    <div class="position-absolute top-0 end-0 mt-2 me-2"></div>
                    <div class="pt-2 mt-1">
                      Law firms require time-sensitive
                      <span class="text-success">legal courier services</span>
                      throughout Miami.
                    </div>
                  </div>
                </div>
              </div>

              <hr class="text-muted opacity-25 my-1 w-100 mx-auto" />

              <!-- Actions Container -->
              <div class="row g-2">
                <!-- Row 1: Approve & Edit -->
                <div class="col-6 p-1">
                  <button
                    class="btn btn-success w-100 fw-bold btn-desicion-mapping d-flex justify-content-center align-items-center gap-2 py-2 shadow-sm btn-actions"
                    onmouseover="this.style.transform = 'translateY(-1px)'"
                    onmouseout="this.style.transform = 'none'"
                  >
                    <i class="fas fa-check-circle pr-1"></i> Approve &amp;
                    Implement
                  </button>
                </div>
                <div class="col-6 p-1">
                  <button
                    class="btn btn-outline-secondary w-100 fw-bold bg-white btn-desicion-mapping d-flex justify-content-center align-items-center gap-2 py-2 btn-actions"
                  >
                    <i class="fas fa-pencil-alt pr-1"></i> Edit Action
                  </button>
                </div>
                <!-- Row 2: Ask AI & Reject -->
                <div class="col-6 p-1">
                  <button
                    class="btn btn-outline-primary w-100 fw-bold bg-white btn-desicion-mapping d-flex justify-content-center align-items-center gap-2 py-2 btn-actions"
                    onmouseover="this.style.backgroundColor = '#f3e8fa'"
                    onmouseout="this.style.backgroundColor = '#ffffff'"
                  >
                    <i class="fas fa-robot pr-1"></i> Ask AI
                  </button>
                </div>
                <div class="col-6 p-1">
                  <button
                    class="btn btn-outline-danger w-100 fw-bold bg-white btn-desicion-mapping d-flex justify-content-center align-items-center gap-2 py-2 btn-actions"
                  >
                    <i class="fas fa-ban pr-1"></i> Reject
                  </button>
                </div>
                <!-- Row 3: Send full width -->
                <div class="col-12 p-1">
                  <button
                    class="btn btn-primary bg-primary bg-opacity-10 text-white border-0 w-100 fw-bold btn-desicion-mapping d-flex justify-content-center align-items-center gap-2 py-2"
                    style="height: 26px; font-size: 11px"
                    onmouseover="
                      this.classList.replace('bg-opacity-10', 'bg-opacity-25')
                    "
                    onmouseout="
                      this.classList.replace('bg-opacity-25', 'bg-opacity-10')
                    "
                  >
                    <i class="fas fa-paper-plane pr-1"></i> Send Production Need
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12 d-flex">
          <div class="card shadow-sm border-0 mt-0 flex-grow-1">
            <div class="card-body">
              <div class="d-flex justify-content-between mb-2">
                <h4
                  class="fw-bold mb-0 text-uppercase"
                  style="font-size: 0.75rem"
                >
                  <strong>RECENT LINK ACTIONS</strong>
                </h4>
                <a
                  href="#"
                  class="text-primary text-decoration-none d-flex align-items-center"
                  style="font-size: 0.75rem"
                  >View all actions <i class="fas fa-arrow-right ms-1"></i
                ></a>
              </div>
              <div class="d-flex gap-3">
                <div
                  class="bg-white p-2 border rounded flex-grow-1 mr-1 d-flex flex-column justify-content-between"
                  style="font-size: 0.7rem"
                >
                  <div>
                    <div
                      class="d-flex align-items-center fw-bold text-dark mb-1"
                    >
                      <i class="fas fa-robot text-primary me-2 pr-1"></i>
                      <strong>AI Auto-Executed</strong>
                    </div>
                    <div class="text-muted">
                      Updated 28 redirected links to direct destinations
                    </div>
                  </div>
                  <div class="text-end text-muted mt-2">2h ago</div>
                </div>
                <div
                  class="bg-white p-2 border rounded flex-grow-1 mr-1 d-flex flex-column justify-content-between"
                  style="font-size: 0.7rem"
                >
                  <div>
                    <div
                      class="d-flex align-items-center fw-bold text-success mb-1"
                    >
                      <i class="fas fa-check-circle me-2 pr-1"></i>
                      <strong>Implemented</strong>
                    </div>
                    <div class="text-muted">
                      Added link from /services/same-day/ to
                      /same-day-legal-courier/
                    </div>
                  </div>
                  <div class="text-end text-muted mt-2">3h ago</div>
                </div>
                <div
                  class="bg-white p-2 border rounded flex-grow-1 mr-1 d-flex flex-column justify-content-between"
                  style="font-size: 0.7rem"
                >
                  <div>
                    <div
                      class="d-flex align-items-center fw-bold text-warning mb-1"
                    >
                      <i class="fas fa-user-check me-2 pr-1"></i>
                      <strong>Human Approved</strong>
                    </div>
                    <div class="text-muted">
                      Added link from /about-us/ to /careers/
                    </div>
                  </div>
                  <div class="text-end text-muted mt-2">5h ago</div>
                </div>
                <div
                  class="bg-white p-2 border rounded flex-grow-1 mr-1 d-flex flex-column justify-content-between"
                  style="font-size: 0.7rem"
                >
                  <div>
                    <div
                      class="d-flex align-items-center fw-bold text-warning mb-1"
                    >
                      <i class="fas fa-user-edit me-2 pr-1"></i>
                      <strong>Human Edited</strong>
                    </div>
                    <div class="text-muted">
                      Updated anchor on /contact/ to /faq/
                    </div>
                  </div>
                  <div class="text-end text-muted mt-2">1d ago</div>
                </div>
                <div
                  class="bg-white p-2 border rounded flex-grow-1 d-flex flex-column justify-content-between"
                  style="font-size: 0.7rem"
                >
                  <div>
                    <div
                      class="d-flex align-items-center fw-bold text-danger mb-1"
                    >
                      <i class="fas fa-times-circle me-2 pr-1"></i>
                      <strong>Rejected</strong>
                    </div>
                    <div class="text-muted">
                      AI proposal from /services/ to /medical-courier/
                    </div>
                  </div>
                  <div class="text-end text-muted mt-2">1d ago</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-4 d-flex pl-0"></div>
        <div
          *ngIf="loading"
          class="d-flex justify-content-center align-items-center"
          style="min-height: 400px"
        >
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
